module.exports = __webpack_public_path__ + "img/Metropole.04986bd1.png";